
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { iTipoAnalisis } from '../models/iTipoAnalisis'
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class TableService {

  public tableList: any;


  public getTable() {
      return this.tableList;
  }

}

